import { ROUTES } from '~/utils/routes';
import { useInternalNewsDetailHeader } from './hooks/useInternalNewsDetailHeader';
import { InternalNewsDetailHeaderPresentation } from './presentations';

type Props = {
  newsId: number;
};

/**
 * 社内報詳細ヘッダー Container コンポーネント
 * API から取得した社内報タイトルをパンくずリスト付きヘッダーに表示する
 */
export const InternalNewsDetailHeader: React.FC<Props> = ({ newsId }) => {
  const { title } = useInternalNewsDetailHeader({ newsId });

  return (
    <InternalNewsDetailHeaderPresentation title={title} indexHref={ROUTES.INTERNAL_NEWS.INDEX} />
  );
};
